<template>
  <div class="container my-4">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h2 class="fw-bold">Manage Pages</h2>
      <button @click="addNewPage" class="btn btn-primary">
        <i class="bi bi-plus-circle me-2"></i>Add New Page
      </button>
    </div>

    <!-- Page List -->
    <div class="table-responsive">
      <table class="table table-striped table-hover align-middle">
        <thead class="table-dark">
        <tr>
          <th>Title</th>
          <th>Status</th>
          <th class="text-end">Actions</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(page, index) in pages" :key="index">
          <td>{{ page.title }}</td>
          <td>
              <span
                  :class="page.active ? 'badge bg-success' : 'badge bg-secondary'"
              >
                {{ page.active ? 'Active' : 'Inactive' }}
              </span>
          </td>
          <td class="text-end">
            <!-- Three Dot Dropdown Menu -->
            <div class="dropdown">
              <button
                  class="btn btn-outline-secondary dropdown-toggle"
                  type="button"
                  id="dropdownMenuButton"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
              >
                <i class="bi bi-three-dots"></i>
              </button>
              <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton">
                <li>
                  <button @click="editPage(page.id)" class="dropdown-item">
                    <i class="bi bi-pencil-square"></i> Edit
                  </button>
                </li>
<!--                <li>-->
<!--                  <button @click="addComponent(page.id)" class="dropdown-item">-->
<!--                    <i class="bi bi-plus-circle"></i> Add Component-->
<!--                  </button>-->
<!--                </li>-->
<!--                <li>-->
<!--                  <button @click="deactivatePage(page.id)" :disabled="!page.active" class="dropdown-item">-->
<!--                    <i class="bi bi-x-circle"></i> Deactivate-->
<!--                  </button>-->
<!--                </li>-->
                <li>
                  <button @click="deletePage(page.id)" class="dropdown-item text-danger">
                    <i class="bi bi-trash"></i> Delete
                  </button>
                </li>
              </ul>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageView',
  data() {
    return {
      pages: [],
    };
  },
  created() {
    this.fetchPages();
  },
  methods: {
    async fetchPages() {
      try {
        const response = await fetch('/dashboard/pages/'); // Replace with your actual Django endpoint
        const data = await response.json();
        this.pages = data;
      } catch (error) {
        console.error('Failed to fetch pages:', error);
      }
    },
    addNewPage() {
      console.log("Add new page");
      this.$router.push('/add-page');
    },
    editPage(pageId) {
      console.log(`Edit page: ${pageId}`);
      this.$router.push(`/edit-page/${pageId}`);
    },
    addComponent(pageId) {
      console.log(`Add component to page: ${pageId}`);
      this.$router.push(`/add-component/${pageId}`);
    },
    deactivatePage(pageId) {
      console.log(`Deactivate page: ${pageId}`);
      this.pages = this.pages.map(page =>
          page.id === pageId ? {...page, active: false} : page
      );
    },
    deletePage(pageId) {
      console.log(`Delete page: ${pageId}`);
      this.pages = this.pages.filter(page => page.id !== pageId);
    },
  },
};
</script>

<style scoped>
.table {
  width: 100%;
  text-align: left;
}

.badge {
  padding: 0.5em 0.75em;
}

.table-responsive {
  background-color: #ffffff;
  border-radius: 0.5rem;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.table-striped > tbody > tr:nth-of-type(odd) {
  background-color: #f8f9fa;
}

.table-hover tbody tr:hover {
  background-color: #e9ecef;
}

thead.table-dark {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}

h2.fw-bold {
  color: #343a40;
}

.dropdown-menu {
  min-width: 180px;
}

.dropdown-item i {
  margin-right: 8px;
}
</style>
